import FeaturesContainer from './FeaturesContainer';

const ExploreSolutions = ({ history }) => {
	return (
		<FeaturesContainer
			history={history}
			pageName={'explore-solutions'}
			nextUrl={'real-time-location'}
			pageEvent={'OnboardingReceivedAnswersShown'}
			clickEvent={'onboardingReceivedAnswersSubmitted'}
		/>
	);
};

export default ExploreSolutions;
